import { Component } from '@angular/core';
import { ShiftDataService } from '../shift-data.service';
import { MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from 'app/services/dashboard.service';

@Component({
    selector: 'app-verification-status-filter-dialog',
    templateUrl: './verification-status-filter-dialog.component.html',
    styleUrls: ['./verification-status-filter-dialog.component.scss'],
})
export class VerificationStatusFilterDialogComponent {

    verification_status_options: any[] = ['Staff Verification','AI Validation','AI Rejection'];
    verificationStatusSelected : any[]=[];

    constructor(
        public shiftDataService: ShiftDataService,
        public dialogRef: MatDialogRef<VerificationStatusFilterDialogComponent>,
        public dashboardService: DashboardService
    ) {
        this.verificationStatusSelected = this.shiftDataService.verification_type;
    }

    onSectionSelect(verification_type: any,checked:any) {
        /*based on the checked status we need to remove or push that selection vlaue to verification_type*/
        verification_type = (verification_type === 'Staff Verification') ? 'STAFF_VERFICATION' :
        (verification_type === 'AI Validation') ? 'AI_VALIDATION' : 'AI_REJECTED' ;
        if(checked){
            this.verificationStatusSelected.push(verification_type); 
        }
        else{
            const index = this.verificationStatusSelected.findIndex((element) => element === verification_type);
            this.verificationStatusSelected.splice(index, 1);
        }
    }

    onSubmitClick() {
        this.shiftDataService.verification_type = this.verificationStatusSelected ;
        this.shiftDataService.applyVerificationFilters(this.shiftDataService.verification_type);
        localStorage.setItem('selectedFilterWithVerificationType', JSON.stringify(this.shiftDataService.verification_type));
        this.dialogRef.close();
    }

    isChecked(verification_type: string) { 
        verification_type = (verification_type === 'Staff Verification') ? 'STAFF_VERFICATION' :
        (verification_type === 'AI Validation') ? 'AI_VALIDATION' : 'AI_REJECTED' ;
        const index = this.shiftDataService.verification_type.findIndex((element) => element === verification_type);
        return index > -1 ? true : false; 
    }
}